import { Button, IconButton, Menu, MenuItem } from '@material-ui/core'
import { ArrowDropDown, ChevronLeft, ChevronRight } from '@material-ui/icons'
import { useState } from 'react'

interface Props {
  rows: number
  rowsPerPage: number
  setRowsPerPage: (rowsPerPage: number) => void
  page: number
  setPage: (page: number) => void
  className?: string
}
const PaginatedResPagination = ({
  rows,
  rowsPerPage,
  setRowsPerPage,
  page,
  setPage,
  className,
}: Props) => {
  const [rowsPerPageMenu, setRowsPerPageMenu] = useState<null | HTMLElement>(
    null
  )
  const [pageMenu, setPageMenu] = useState<null | HTMLElement>(null)

  const pages = Math.ceil(rows / rowsPerPage)
  const pageArr: number[] = Array.from({ length: pages }, (_, i) => i + 1)

  const handleChangeRowsPerPage = (value: number) => {
    setPage(0)
    setRowsPerPage(value)
    setRowsPerPageMenu(null)
  }

  const handlePageMenuChange = (value: number) => {
    setPage(value)
    setPageMenu(null)
  }

  const handleBackButtonClick = () => {
    setPage(page - 1)
  }

  const handleNextButtonClick = () => {
    setPage(page + 1)
  }

  return (
    <div className={`pagination ${className}`}>
      <div className="page-rows flex align-center" style={{ width: '33%' }}>
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={(event) => setRowsPerPageMenu(event.currentTarget)}
          color="secondary"
          variant="outlined"
          className="menu"
        >
          <div>{rowsPerPage}</div>
          <ArrowDropDown className="m-l-5" />
        </Button>

        <Menu
          id="rows-per-page"
          anchorEl={rowsPerPageMenu}
          open={Boolean(rowsPerPageMenu)}
          onClose={() => setRowsPerPageMenu(null)}
          PaperProps={{
            style: {
              left: '0%',
              transform: 'translateX(10px) translateY(calc(-50% - 20px))',
            },
          }}
        >
          <MenuItem
            className={rowsPerPage === 25 ? 'active' : ''}
            onClick={() => handleChangeRowsPerPage(25)}
          >
            25
          </MenuItem>
          <MenuItem
            className={rowsPerPage === 50 ? 'active' : ''}
            onClick={() => handleChangeRowsPerPage(50)}
          >
            50
          </MenuItem>
          <MenuItem
            className={rowsPerPage === 100 ? 'active' : ''}
            onClick={() => handleChangeRowsPerPage(100)}
          >
            100
          </MenuItem>
          <MenuItem
            className={rowsPerPage === 250 ? 'active' : ''}
            onClick={() => handleChangeRowsPerPage(250)}
          >
            250
          </MenuItem>
        </Menu>
        <div className="m-l-20 flex rows-per-page">per page</div>
      </div>

      <div
        className="page-controls flex align-center justify-center"
        style={{ width: '33%' }}
      >
        <div className="flex align-center">
          <IconButton
            onClick={handleBackButtonClick}
            disabled={page === 0}
            aria-label="previous page"
            className="m-r-10"
          >
            <ChevronLeft />
          </IconButton>
          <div className="m-r-10 m-t-3 flex align-center">Page</div>
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={(event) => setPageMenu(event.currentTarget)}
            color="secondary"
            variant="outlined"
            className="menu"
          >
            <div className="flex align-center">{page + 1}</div>
            <ArrowDropDown className="m-l-5" />
          </Button>
          <div className="m-l-10 m-t-3">of {pages}</div>
          <Menu
            id="rows-per-page"
            anchorEl={pageMenu}
            open={Boolean(pageMenu)}
            onClose={() => setPageMenu(null)}
            PaperProps={{
              style: {
                left: '0%',
                transform: 'translateX(10px) translateY(calc(0% - 20px))',
              },
            }}
          >
            {pageArr.map((item, index) => (
              <MenuItem
                key={item}
                className={page + 1 === item ? 'active' : ''}
                onClick={() => handlePageMenuChange(item - 1)}
              >
                {item}
              </MenuItem>
            ))}
          </Menu>
        </div>

        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= pages - 1}
          aria-label="next page"
          className="m-l-10"
        >
          <ChevronRight />
        </IconButton>
      </div>
      <div className="flex flex-end" style={{ width: '33%' }}>
        <div>{rows} results</div>
      </div>
    </div>
  )
}

export default PaginatedResPagination
